import { CarsType } from '@/typings/common';

/** Парсит сегмент URL в id авто для stock-service. */
export const parseStockCarIdFromSlug = (value?: string): string | null => {
  if (!value) {
    return null;
  }

  return decodeURIComponent(value);
};

const isStockCarIdSegment = (segment: string): boolean => {
  if (/^\d+$/.test(segment)) {
    return true;
  }

  if (/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-/i.test(segment)) {
    return true;
  }

  // Смешанный id (буквы + цифры), но не brand-slug и не filter-*
  if (/[A-ZА-ЯЁ]/i.test(segment) && /\d/.test(segment)) {
    return true;
  }

  return false;
};

/**
 * Определяет, что slug ведёт на карточку авто (/cars/{type}/{id}),
 * а не на листинг с фильтром по бренду (/cars/{type}/{brand-slug}).
 */
export const isDetailedCarPageSlug = (
  slug?: string[],
  carType?: CarsType
): boolean => {
  if (slug?.length !== 2) {
    return false;
  }

  const [type, idSegment] = slug;

  if (!type || !idSegment || (carType && type !== carType)) {
    return false;
  }

  const segment = decodeURIComponent(idSegment);

  if (segment.startsWith('filter-')) {
    return false;
  }

  return isStockCarIdSegment(segment);
};
